/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/

import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiInstanceV2 } from '../../Apis/AxiosV2';
import { UploadImage } from '../ShareSlice/shareApi';
import { apiInstance } from '../../Apis/Axios';
import { GetVehicleImgUsingId } from '../Contractor/ContractorApi';
import { IMAGE_SERVICE, STATUS_SERVICE, VEHICLE_COMPANY_SERVICE, VEHICLE_SERVICE } from '../EndPoints';

//List all the Employee
export const GetAllVehicle = createAsyncThunk(
    'vehicleSection/getAllVehicle',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .post(VEHICLE_COMPANY_SERVICE.getAllVehicle, params)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// @create vehicle
export const CreateVehicleEmployee = createAsyncThunk(
    'vehicleSection/createVehicleEmployee',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .post(VEHICLE_SERVICE.createVehicleEmployee, params?.vehicleData)
            .then(function (response) {
                if (params?.imageFile) {
                    const imgData = {
                        vehicle: {
                            id: response?.data?.data?.id,
                        },
                        accessMethod: {
                            id: '5',
                        },
                        description: 'Face recognition',
                    };
                    dispatch(CreateVehicleImage({ imgData, file: params?.imageFile }));
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// get status of the vehicle
export const GetVehicleStatus = createAsyncThunk(
    'vehicleSection/getVehicleStatus',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .get(STATUS_SERVICE.getVehicleStatus)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// get tags of the vehicle
export const GetVehicleTags = createAsyncThunk(
    'vehicleSection/getVehicleTags',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .get(STATUS_SERVICE.getVehicleTags)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
// vehicle image create
export const CreateVehicleImage = createAsyncThunk(
    'vehicleSection/createVehicleImage',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .post(VEHICLE_SERVICE.createVehicleImage, params?.imgData)
            .then(function (response) {
                // this api need id, file and option
                let formData = new FormData();
                formData.append('id', response?.data?.data?.id);
                formData.append('option', 'vehicle');
                formData.append('file', params?.file);
                dispatch(UploadImage(formData));
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//@update vehicle
//get vehicle by it id
export const GetVehicleById = createAsyncThunk(
    'vehicleSection/getVehicleById',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .get(`${VEHICLE_SERVICE.getVehicleById}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);


// update vehicle data
export const UpdateVehicleV1 = createAsyncThunk(
    'vehicleSection/updateVehicleV1',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .put(VEHICLE_SERVICE.updateVehicleV1, params?.vehicleData)
            .then(function (response) {
                if (params?.updateImage) {
                    dispatch(GetVehicleImgUsingId(response?.data?.data?.id)).then(
                        ({
                            payload: {
                                data: { data },
                            },
                        }) => {
                            let formData = new FormData();
                            formData.append('id', data?.id);
                            formData.append('option', 'vehicle');
                            formData.append('file', params?.imageFile);
                            dispatch(UploadImage(formData));
                        },
                    );
                } else {
                    if (params?.imageFile) {
                        const imgData = {
                            vehicle: {
                                id: response?.data?.data?.id,
                            },
                            accessMethod: {
                                id: '5',
                            },
                            description: 'Face recognition',
                        };
                        dispatch(CreateVehicleImage({ imgData, file: params?.imageFile }));
                    }
                }
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
//@vehicle Detail

//get all driver with relation to user and vehicle by vehicleID
export const GetAllDriverRelationship = createAsyncThunk(
    'vehicleSection/getAllDriverRelationship',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .get(`${VEHICLE_COMPANY_SERVICE.getAllDriverRelationship}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//get all permissionType
export const PremmissionType = createAsyncThunk(
    'vehicleSection/premmissionType',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .get(VEHICLE_COMPANY_SERVICE.premmissionType)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//get all permissionType
export const PermissionByUser = createAsyncThunk(
    'vehicleSection/permissionByUser',
    async (params, { dispatch, getState }) => {
        let result = await apiInstance
            .get(`${VEHICLE_COMPANY_SERVICE.permissionByUser}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//add driver to vehicle
export const AddDriver = createAsyncThunk('vehicleSection/addDriver', async (params, { dispatch, getState }) => {
    let result = await apiInstanceV2
        .post(VEHICLE_COMPANY_SERVICE.addDriver, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});
//Remove driver to vehicle
export const RemoveDriverEmployee = createAsyncThunk(
    'vehicleSection/removeDriverEmployee',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .delete(`${VEHICLE_COMPANY_SERVICE.removeDriverEmployee}${params}`)
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);

//update driver
export const UpdateDriver = createAsyncThunk('vehicleSection/updateDriver', async (params, { dispatch, getState }) => {
    let result = await apiInstanceV2
        .put(VEHICLE_COMPANY_SERVICE.updateDriver, params)
        .then(function (response) {
            return response;
        })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

//get list of images
export const GetListOfVehicleImages = createAsyncThunk(
    'vehicleSection/getListOfVehicleImages',
    async (params, { dispatch, getState }) => {
        let result = await apiInstanceV2
            .post(
                `${VEHICLE_SERVICE.getListOfVehicleImages}${params?.vehicleId}`,
                params.pagination,
            )
            .then(function (response) {
                return response;
            })
            .catch(function (error) {
                return error.response;
            });
        const { data, status } = result;

        return { data, status };
    },
);
